import React, {useEffect} from 'react';
import clsx from 'clsx';
import {
    Menu,
    ClickAwayListener                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
} from "@material-ui/core";
import { 
    MyMenuItem
} from '../../styling/Styles';
import api from '../../services/apiService';

/**
 * 
 * @param {method} props.changeProject - it is called when user clicks on another project in menu with project names
 * @param {number} props.selectedProject - indicates the number of user's selected project
 * @returns a label wich shows current project's name and on hover it opens a dropdown menu with the names of the other projects
 */
const SelectProject = (props) => {

    const{
        changeProject,
        selectedProject
    } = props;

    const [anchorEl, setAnchorEl] = React.useState(); // variable to keep anchor element of dropdown menu with projects names
    const [stateDisplayProjects, setStateDisplayProjects] = React.useState(false); // variable to show-hide dropdown menu with projects names 
    const [selectedProjectName, setSelectedProjectName] = React.useState(); // variable to show current project name
    const [projectsNames, setProjectsNames] = React.useState([]); // table with names of all projects 

    /**
     * This useEffect is runned when component is first rendered and it asks from backend to bring all user's hiddenProjects
     * Then it updates projectNames variable with only the visible projects
     */
    useEffect(() => {
        
        const tempData = JSON.parse(localStorage.getItem('data'));
        api.getUserField('userPreferences')
        .then(response => {
            setProjectsNames(tempData.filter( (element) => !response.data.hiddenProjects.includes(element._id)).map((project) => project.name));
        })
        .catch((err) => {throw err;});  
        
    }, []);

    /**
     * Store to variable selectedProject the value that exists in localStorage
     */
    useEffect( () => {
        
        const tempData = JSON.parse(localStorage.getItem('data'));
        if (selectedProject > -1) setSelectedProjectName(tempData[selectedProject].name);

    },[selectedProject])
    
    // This method opens dropdown menu with projects names 
    const openDisplayProjects = (event) =>{
        setAnchorEl(event.currentTarget);
        setStateDisplayProjects(true);
    
    }

    // This method closes dropdown menu with projects names
    const closeDisplayProjects = () => {
        setStateDisplayProjects(false);
        setAnchorEl(null);
    }

    return(
        <>
            <span 
                id='selectedProjectLabel'
                className={clsx('selectedProjectStyle','teamSelector')}
                onMouseOver={(event) => openDisplayProjects(event)}
                onFocus={(event) => openDisplayProjects(event)}
            >{selectedProjectName}</span>
            {
                stateDisplayProjects === false ?
                <span> &nbsp;</span>
                :
                <ClickAwayListener 
                    onClickAway ={closeDisplayProjects}
                >
                    <span>&nbsp;</span>
                </ClickAwayListener>
            }
            <Menu   
                id='projectsPanel'
                elevation={0}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                keepMounted
                open={stateDisplayProjects}
                MenuListProps={{ onMouseLeave: closeDisplayProjects }}
                >
                    { stateDisplayProjects &&
                        projectsNames.map((option,index) => (
                            <MyMenuItem 
                                id ={`menuItem${index}`}
                                key={option}
                                    onClick ={() => changeProject(option)}
                                > 
                                {option}
                            </MyMenuItem>
                        ))
                    }
            </Menu>              
        </>
    )

}

export default SelectProject;